"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWinOfTheMonth = void 0;
var react_1 = require("react");
var useGame_1 = require("./useGame");
var swr_hooks_1 = require("@l2p/swr-hooks");
var WIN_OF_THE_MONTH = 'WIN_OF_THE_MONTH';
var useWinOfTheMonth = function () {
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var winData = (0, react_1.useMemo)(function () {
        var dataFromLocale = translateLocale(WIN_OF_THE_MONTH, { direct: true });
        if (!dataFromLocale)
            return {};
        return JSON.parse(dataFromLocale);
    }, [translateLocale]);
    var currentGame = (0, useGame_1.useGame)(winData);
    return {
        currentGame: currentGame,
        winData: winData,
    };
};
exports.useWinOfTheMonth = useWinOfTheMonth;
